// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__3YrQQ","Hero-Img":"Hero_Hero-Img__W-9rr"};